export { default as dependentCoverageInactivityReasons } from "./dependentCoverageInactivityReasons";
export { default as dependentCoverageStatuses } from "./dependentCoverageStatuses";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/coverages/enums/index.js